import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('AccountStatsList').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'start',
    width: '100%',
    gap: '6px',
    color: theme.colors.text.primary,
  },

  listItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },

  title: {
    fontFamily: 'Inter',
    fontWeight: '370',
    fontSize: '13px',
    lineHeight: theme.sizes.texts.lineHeight.s,

    color: theme.colors.text.secondary,
    display: 'flex',
    gap: '4px',
  },

  titleName: {
    textTransform: 'uppercase',
  },

  revard: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
    fontFamily: 'Space Grotesk',
    padding: '4px 8px',
    fontSize: theme.sizes.texts.fontSize.s,
    fontWeight: '540',
    flexWrap: 'nowrap',
    width: '100%',
    borderRadius: '12px',
    background: 'rgba(96, 125, 252, 0.2)',
  },

  coinIcon: {
    width: '16px',
    height: '16px',
  },

  value: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    fontFamily: 'Space Grotesk',
    fontSize: '21px',
    fontWeight: '470',
    lineHeight: theme.sizes.texts.lineHeight.m,

    textTransform: 'uppercase',
    // width: '100%',

    textAlign: 'right',
    span: {
      fontFamily: 'Inter',
    },
  },
}))
